import { z } from 'zod';
import { MarketConfigInputSchema } from './market.schema';
import { TimeframeConfigInputSchema } from './timeframe.schema';
import { PositionManagementConfigInputSchema } from './position-management.schema';
import { TradingScheduleConfigInputSchema } from './trading-schedule.schema';

export const DataFeedInputSchema = z.object({
  feedId: z.string(),
  marketConfig: MarketConfigInputSchema,
  timeframes: z.array(TimeframeConfigInputSchema),
  positionManagementConfig: PositionManagementConfigInputSchema.optional(),
  tradingScheduleConfig: TradingScheduleConfigInputSchema.optional()
});

export type DataFeedInput = z.infer<typeof DataFeedInputSchema>;
